<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"
                 rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-toast [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}"></p-toast>

<router-outlet></router-outlet>
